import { Button, Heading } from '@assembly-js/design-system';
import React from 'react';

import { useFileIcon } from 'src/hooks/useFileIcon';

export const NoPreviewAvailable: React.FC<{
  fileType: string;
  onDownloadClicked: () => void;
  onNoPreview: () => void;
}> = ({ fileType, onDownloadClicked, onNoPreview }) => {
  const { getIcon } = useFileIcon();
  const fileIcon = getIcon(fileType);

  // whe no preview is rendered we want to hide the
  // download button from the header and show it in the no preview component
  // calling the noPreview callback will handle this side-effect
  React.useEffect(() => {
    onNoPreview();
  }, []);

  return (
    <div className="h-screen flex-col gap-3 w-full flex items-center justify-center text-white">
      {fileIcon}
      <Heading size="lg">No preview available</Heading>
      <Button
        className="bg-white text-black"
        label="Download"
        onClick={onDownloadClicked}
        prefixIcon="Download"
      />
    </div>
  );
};
